import angular from "angular";

angular
    .module('app')
    .component('courseGroupsAndStudents', {
        template: require('./course-groups-and-students.html'),
        controller: ['$http', 'Notifier', '$uibModal', controller],
        bindings: {
            course: '<',
            groups: '<',
            chapters: '<',
        }
    });

function controller($http, Notifier, $uibModal) {

    let $ctrl = this;

    $ctrl.status = null;
    $ctrl.openGroupForm = function (group) {
        $uibModal
            .open({
                component: 'courseGroupForm',
                size: 'xl',
                backdrop: 'static',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    group: function () {
                        return group;
                    },
                    chapters: function () {
                        return $ctrl.chapters;
                    }
                }
            })
            .result
            .then(
                function (res) {
                    $ctrl.groups.unshift(res);
                },
                function () {
                }
            );
    };

}
